import router from '@/router'
import { navigateTo } from '@/router/navigateTo'
import { useDossierTTStore } from './useDossierTTStore.ts'

export function useDossierTTRoutingService() {
  const store = useDossierTTStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToRechercheDossiersList() {
    const backPath = window.history.state.back as string | undefined
    const isBackToRecherche = backPath && /\/tt\/dossiers(\?|$)/.test(backPath)

    if (isBackToRecherche) {
      router.go(-1)
    } else {
      return navigateTo({
        to: 'recherche',
        domaine: 'tt',
        module: 'dossier'
      })
    }
  }

  return { loadStoreWithKey, navigateToRechercheDossiersList }
}
